import React from "react";
import "./style.css";
import Layout from './Layout';

export class LayoutImpressao extends React.PureComponent {    
    render() {
        return (
            <div>
                <Layout/>
            </div>
        );
     }
} 



